import { selectCostCenterState } from 'modules/settings/submodules/clients/costCenters/store/selectors';
import { IStore } from 'store/configureStore';

export const selectCostCenterFilter = (state: IStore): string => {
    const costCenterState = selectCostCenterState(state);
    return costCenterState.costCenterFilter;
};
